module.exports = __webpack_public_path__ + "static/media/dschungel.99f83d9d.png";